module.exports = __webpack_public_path__ + "img/UTCORA-3.a0b28174.jpg";